import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import {
  STR_APP_NAME,
  STR_GET_STARTED,
  STR_WELCOME,
} from "../Strings";

import logo_icon from "../assets/logo_icon.png";
import logo_worded_only2 from "../assets/logo_worded_only2.png";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("launch");

  async function init() {
    // Initial initialization logic
  }

  async function getStarted() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div className="Login bg-background">

      {
        (loginStep === 'launch') ?
          <div className="launch mNoScrollBar">

            {/* Main Wrapper */}
            <div
              style={{
                width: "100%",
                minHeight: "100vh",
                position: "relative",
                overflow: "hidden",
                background: "#0f172a", // Deep slate background
                color: "#f8fafc",
              }}
            >

              {/* Decorative Gradient Blobs (Masculine Palette) */}
              <div
                style={{
                  position: "absolute",
                  width: "400px",
                  height: "400px",
                  borderRadius: "400px",
                  top: "-100px",
                  left: "-100px",
                  background: "radial-gradient(circle at 30% 30%, rgba(30, 64, 175, 0.35), rgba(30, 64, 175, 0) 60%)",
                  pointerEvents: "none",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  width: "450px",
                  height: "450px",
                  borderRadius: "450px",
                  bottom: "-150px",
                  right: "-150px",
                  background: "radial-gradient(circle at 60% 40%, rgba(16, 185, 129, 0.2), rgba(16, 185, 129, 0) 60%)",
                  pointerEvents: "none",
                }}
              />

              {/* Content Container */}
              <div
                className="container"
                style={{
                  position: "relative",
                  zIndex: 2,
                  paddingTop: "26px",
                  paddingBottom: "26px",
                  height: "100%",
                }}
              >
                <div className="row" style={{ minHeight: "100vh" }}>

                  {/* Top Brand/Logo Section */}
                  <div
                    className="col-md-6"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >

                    {/* Logo Wordmark */}
                    <div style={{ marginTop: "16px", filter: "drop-shadow(0px 4px 8px rgba(0,0,0,0.5))" }}>
                      <img
                        src={logo_worded_only2}
                        alt="WATU Logo"
                        style={{
                          width: "210px",
                          height: "auto",
                        }}
                      />
                    </div>

                    {/* Branding/Tagline */}
                    <div
                      className="text-center"
                      style={{
                        marginTop: "18px",
                        maxWidth: "340px",
                      }}
                    >
                      <h1 className="font-bold mNoMargin" style={{ fontSize: "28px", letterSpacing: "1px" }}>
                        WATU
                      </h1>
                      <p
                        className="mNoMargin font-semi-bold"
                        style={{
                          fontSize: "18px",
                          lineHeight: "22px",
                          color: "#10b981", // Emerald accent
                          marginTop: "4px"
                        }}
                      >
                        Wanaume Tusaidiane
                      </p>
                      <p
                        className="font-regular"
                        style={{
                          fontSize: "15px",
                          marginTop: "12px",
                          opacity: 0.7,
                          lineHeight: "20px"
                        }}
                      >
                        {appContext.language === 'en' 
                          ? "Strengthening brotherhood through monthly contributions and shared growth." 
                          : "Kuimarisha udugu kupitia michango ya kila mwezi na ukuaji wa pamoja."}
                      </p>
                    </div>

                  </div>

                  {/* Action Card Section */}
                  <div
                    className="col-md-6"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingTop: "18px",
                      paddingBottom: "28px",
                    }}
                  >
                    <div
                      className="card mShadow3"
                      style={{
                        width: "100%",
                        maxWidth: "420px",
                        borderRadius: "28px",
                        background: "rgba(30, 41, 59, 0.75)",
                        backdropFilter: "blur(16px)",
                        WebkitBackdropFilter: "blur(16px)",
                        border: "1px solid rgba(255, 255, 255, 0.08)",
                        color: "#fff"
                      }}
                    >
                      <div style={{ padding: "30px" }}>
                        
                        {/* Status Accent Line */}
                        <div
                          style={{
                            width: "100%",
                            height: "4px",
                            borderRadius: "10px",
                            background: "linear-gradient(90deg, #1d4ed8, #10b981)",
                            marginBottom: "18px",
                          }}
                        />

                        <h6
                          className="font-semi-bold mNoMargin"
                          style={{
                            fontSize: "18px",
                            marginBottom: "8px",
                          }}
                        >
                          {appContext.language === 'en' ? "Member Portal" : "Lango la Mwanachama"}
                        </h6>

                        <p
                          className="font-regular"
                          style={{
                            fontSize: "14px",
                            margin: 0,
                            opacity: 0.65,
                            lineHeight: "20px",
                          }}
                        >
                          {appContext.language === 'en' 
                            ? "Track your contributions, check penalties, and manage your membership." 
                            : "Fuatilia michango yako, kagua faini, na dhibiti uanachama wako."}
                        </p>

                        {/* Primary action */}
                        <button
                          className="btn btn-padded btn-block btn-rounded"
                          style={{
                            marginTop: "24px",
                            textTransform: "capitalize",
                            fontSize: "15px",
                            fontWeight: "600",
                            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                            color: "white",
                            border: "none",
                            padding: "14px"
                          }}
                          onClick={() => getStarted()}
                        >
                          {STR_GET_STARTED[appContext.language]}
                        </button>

                        {/* Secondary action / Language Toggle */}
                        <button
                          className="btn btn-padded btn-block btn-outline-light btn-rounded"
                          style={{
                            marginTop: "12px",
                            textTransform: "capitalize",
                            fontSize: "14px",
                            borderColor: "rgba(255,255,255,0.2)"
                          }}
                          onClick={() => appContext.changeLanguage()}
                        >
                          {(appContext.language === 'en') ? "Tumia Kiswahili" : "Switch to English"}
                        </button>

                        {/* Group Footer Note */}
                        <div className="text-center" style={{ marginTop: "20px" }}>
                          <p
                            className="mNoMargin font-regular"
                            style={{
                              fontSize: "12px",
                              opacity: 0.4,
                              letterSpacing: "0.5px"
                            }}
                          >
                            &copy; 2026 WATU • Wanaume Tusaidiane
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>
          : ""
      }

    </div>
  )
}